import {default as Component} from './AccountManagementForm'
import {changePaymentMethod} from '../../redux/actions'
import {addPaymentMethod} from '../../redux/endpointActions'
import {connect} from 'react-redux'

const servicePath = 'user/account/payment'

const AccountManagementForm = connect(
    (state) => ({
        disabled: state.accountData.disabled,
        err: state.accountData.err,
    }),
    (dispatch) => ({
        dispatch: dispatch
    }),
    (stateProps, dispatcherProps) => ({
        disabled: stateProps.disabled,
        err: stateProps.err,
    })
)(Component)

AccountManagementForm.defaultProps = {
    paymentMethod: null,
    disabled: null,
    paymentMethodChanged: null,
    submit: null
}

export default AccountManagementForm  


// WEBPACK FOOTER //
// ./src/components/AccountManagementForm/index.js